import React, { Component } from "react";

import withStyles from "@material-ui/core/styles/withStyles";
import { createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";

import { connect } from "react-redux";

import ReactTable from "react-table";

import loaderIcon from "assets/img/loader.gif";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import green from "@material-ui/core/colors/green";
import Icon from "@material-ui/core/Icon";
import Tooltip from "@material-ui/core/Tooltip";

import DeleteModel from "components/Common/FevoModels/DeleteModel";
import { getAllCategories$ } from "../../../redux/actions/category";

import axios from "../../../config/axios";

import toastr from "toastr";

import "./style.css";
const formStyle = {
  minWidth: "100%",
  margin: "0 1.2rem 1.2rem 0"
};
class ManageCategory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showConfirmModal: false,
      categoryDeletedIndex: null,
      categoryTobeDeleted: null,
      showDeleteCategoryModal: false,
      catData: [],
      category_name: null
    };
  }

  componentDidMount() {
    this.props.handleGetCategoryList();
  }

  componentDidUpdate(prevProps) {
    if (this.props.categoryListData !== prevProps.categoryListData) {
      if (this.props.categoryListData.data.length > 0) {
        this.setState({ catData: this.props.categoryListData.data });
      } else {
        this.setState({ catData: [] });
      }
    }
  }

  getUserTableColumn = () => {
    const { classes } = this.props;
    const theme = createMuiTheme({
      palette: {
        primary: green
      }
    });
    let column = [
      {
        Header: "Category Name",
        accessor: "name",
        headerStyle: { textAlign: "center" }
      },
      {
        Header: "Actions",
        accessor: "actions",
        sortable: false,
        filterable: false,
        headerStyle: { textAlign: "center" },
        Cell: category => {
          return (
            <div className="actions-center">
              <Tooltip title="Edit">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.props.history.push(
                      "/admin/managecategory/editcategory",
                      {
                        action: "edit",
                        category: category.original
                      }
                    );
                  }}
                >
                  <Icon>edit_icon</Icon>
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Category">
                <IconButton
                  color="primary"
                  className={classes.button}
                  onClick={e => {
                    e.stopPropagation();
                    this.handleCategoryDeleteChange(
                      category.original,
                      category.index
                    );
                  }}
                >
                  <Icon>delete_icon</Icon>
                </IconButton>
              </Tooltip>
            </div>
          );
        }
      }
    ];
    return column;
  };

  handleCategoryDeleteChange = (categoryTobeDeleted, categoryDeletedIndex) => {
    this.setState({
      categoryDeletedIndex,
      categoryTobeDeleted,
      showDeleteCategoryModal: true
    });
  };

  deleteCategory = (category, index) => {
    axios
      .delete(`categories/${category.id}`)
      .then(res => {
        if (res.status === 200) {
          toastr.success("Category Deleted Successfully!");
          this.handleDeleteModal();
          this.props.handleGetCategoryList();
        }
      })
      .catch(error => toastr.error("Something wrong happened!"));
  };

  handleDeleteModal = () => {
    this.setState(({ showDeleteCategoryModal }) => ({
      showDeleteCategoryModal: !showDeleteCategoryModal,
      categoryDeletedIndex: null,
      categoryTobeDeleted: null
    }));
  };

  pageChange=()=>{
    let node = document.getElementById("event_main_page");
    if (node){
      node.scrollTop = 0
    }
  }
  render() {
    const { showDeleteCategoryModal, category_name, catData } = this.state;
    const { categoryListData, classes } = this.props;
    const { loading, data } = categoryListData;
    return (
      <div>
        {loading ? (
          <div className="loader_icon">
            <img src={loaderIcon} />
          </div>
        ) : (
          <div>
            <GridContainer>
              <GridItem xs={12}>
                <Card>
                  <CardBody>
                    <FormControl
                      className={classes.formControl}
                      style={formStyle}
                    >
                      <TextField
                        id="standard-search"
                        label="Search Category by name"
                        name="category_name"
                        type="search"
                        fullWidth
                        value={category_name}
                        onChange={event => {
                          const { value } = event.target;
                          this.setState(
                            {
                              catData: data
                            },
                            () => {
                              const newEventData = this.state.catData.filter(
                                item =>
                                  item.name
                                    .toLowerCase()
                                    .includes(value.toLowerCase())
                              );
                              this.setState({
                                catData: newEventData,
                                category_name: value.toLowerCase()
                              });
                            }
                          );
                        }}
                        margin="normal"
                      />
                    </FormControl>
                    <ReactTable
                      data={catData}
                      loading={loading}
                      columns={this.getUserTableColumn()}
                      defaultPageSize={25}
                      pageSizeOptions={[25, 50, 100]}
                      showPaginationBottom={true}
                      minRows={5}
                      noDataText="No category found"
                      onPageChange={this.pageChange}
                      onPageSizeChange={this.pageChange}
                      getTrProps={(state, rowInfo, column, instance) => {
                        return {
                          onClick: (e, handleOriginal) => {
                            if (rowInfo) {
                              // this.editCategoryFunc(rowInfo.original);
                            }
                          },
                          style: {
                            textAlign: "center",
                            cursor: "pointer"
                          }
                        };
                      }}
                      getTheadThProps={(state, rowInfo, column, instance) => {
                        return {
                          style: {
                            marginBottom: "13px"
                          }
                        };
                      }}
                    />
                  </CardBody>
                </Card>
              </GridItem>
            </GridContainer>
            <DeleteModel
              showModel={showDeleteCategoryModal}
              title={"Are you sure you want to delete this category?"}
              onCancel={this.handleDeleteModal}
              onOk={() => {
                let { categoryDeletedIndex, categoryTobeDeleted } = this.state;
                this.deleteCategory(categoryTobeDeleted, categoryDeletedIndex);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => {
  console.log(state);
  return {
    categoryListData: state.category
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleGetCategoryList: () => dispatch(getAllCategories$.trigger())
  };
};

const ManageCategoryListComponent = withStyles(extendedTablesStyle)(
  ManageCategory
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCategoryListComponent);



// WEBPACK FOOTER //
// ./src/views/ISEAS/CategoryManagement/index.js